import styled, { keyframes } from 'styled-components';
import Typography from '../../styles/Typography';
import { PlaceholderSize } from './enums';
import { StyledPlaceholderProps } from './types';

export const StyledPlaceholder = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 25.25rem;
  padding: 2.5rem 0 2rem;
`;

const brandBoxMark = encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 280' fill='none'><g stroke='%23090F38' stroke-width='1.6' stroke-linejoin='round' stroke-linecap='round' opacity='0.22'><path d='M40 80l60-30 60 30v60l-60 30-60-30z'/><path d='M40 80l60 30M160 80l-60 30M100 110v60'/></g></svg>`
);

const rise = keyframes`
  from { opacity: 0; transform: translateY(0.5rem) scale(0.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const StyledPlaceholderDecor = styled.div<StyledPlaceholderProps>`
  position: relative;
  border-radius: 100%;
  margin: 0 auto
    ${({ size = PlaceholderSize.Big }) =>
      (size === PlaceholderSize.Big && '1.75rem') ||
      (size === PlaceholderSize.Small && '1rem')};
  background: ${({ size = PlaceholderSize.Big }) =>
    size === PlaceholderSize.Big
      ? 'radial-gradient(circle at 30% 30%, rgba(118,177,89,0.22) 0%, rgba(118,177,89,0.04) 70%)'
      : 'radial-gradient(circle at 30% 30%, rgba(118,177,89,0.18) 0%, rgba(118,177,89,0.03) 70%)'};
  color: var(--brand-ink);
  height: ${({ size = PlaceholderSize.Big }) =>
    size === PlaceholderSize.Big ? '11.375rem' : '6.3125rem'};
  width: ${({ size = PlaceholderSize.Big }) =>
    size === PlaceholderSize.Big ? '11.375rem' : '6.3125rem'};
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${rise} 320ms cubic-bezier(0.34, 1.56, 0.64, 1);

  &::before {
    content: '';
    position: absolute;
    inset: -34%;
    border-radius: 100%;
    background-image: url("data:image/svg+xml;utf8,${brandBoxMark}");
    background-repeat: repeat;
    background-size: 48px 48px;
    background-position: center;
    opacity: 0.85;
    z-index: -1;
    -webkit-mask-image: radial-gradient(
      circle at center,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0) 70%
    );
    mask-image: radial-gradient(
      circle at center,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0) 70%
    );
  }

  &::after {
    content: '';
    position: absolute;
    inset: -6px;
    border-radius: 100%;
    border: 1px solid rgba(118,177,89,0.32);
    pointer-events: none;
  }

  svg {
    height: 1em;
    width: 1em;
    fill: currentColor;
    font-size: ${({ size = PlaceholderSize.Big }) =>
      size === PlaceholderSize.Big ? '5.6875rem' : '3.25rem'};
    position: relative;
    z-index: 1;
  }
`;

export const StyledPlaceholderTitle = styled(
  Typography
)<StyledPlaceholderProps>`
  text-align: center;
  margin-bottom: ${({ size = PlaceholderSize.Big }) =>
    (size === PlaceholderSize.Big && '0.625rem') ||
    (size === PlaceholderSize.Small && '0.375rem')};
  color: var(--ink);
  font-weight: 700;
  font-size: ${({ size = PlaceholderSize.Big }) =>
    size === PlaceholderSize.Big ? '1.375rem' : '1.125rem'};
  letter-spacing: -0.015em;
`;

export const StyledPlaceholderDescription = styled(Typography).attrs({
  forwardedAs: 'p',
})<StyledPlaceholderProps>`
  text-align: center;
  margin-bottom: ${({ size = PlaceholderSize.Big }) =>
    (size === PlaceholderSize.Big && '1.75rem') ||
    (size === PlaceholderSize.Small && '1.25rem')};
  color: var(--muted);
  font-size: 0.9375rem;
  line-height: 1.55;
  max-width: 22rem;
  margin-left: auto;
  margin-right: auto;
`;

export const StyledPlaceholderAction = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
